import {
  Accordion,
  AccordionDetails as BaseAccordionDetails,
  AccordionSummary as BaseAccordionSummary,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Accordion)`
  padding: ${(p) => p.theme.spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing(2)};

  &.Mui-expanded {
    // TODO change it after changing the color on theme by Saman in hole project @Mehdi
    background: #fcfcfd;
    box-shadow: none;
  }

  &.MuiAccordion-root.Mui-expanded::before {
    opacity: 1 !important;
  }

  & .MuiAccordionSummary-root {
    padding: 0 !important;
  }

  & .MuiAccordionDetails-root {
    padding: 0 !important;
  }
`;

export const Summary = styled(BaseAccordionSummary)`
  background: initial;
  min-height: 20px !important;
  align-items: flex-start !important;

  & .MuiAccordionSummary-content {
    margin: 0 !important;
    overflow: hidden !important;
  }
`;

export const ContentSummary = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const Title = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const AccordionDetails = styled(BaseAccordionDetails)``;
